import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import TableCellTypography from 'shared/components/widgets/tabel-cell-typography';

export const employeeManagementListColumns: GridColDef[] = [
  {
    field: 'userSeq',
    headerName: 'No', // Number
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 80,
    minWidth: 80,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => {
      return (
        <TableCellTypography>
          {params?.row?.id || params?.row?.id === 0 ? params?.row?.id : '--'}
        </TableCellTypography>
      );
    },
  },
  {
    field: 'joinTp',
    headerName: '가입구분', // Subscription Category
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 128,
    minWidth: 128,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => {
      let subscriptionLabel = '--';
      const subscriptionValue = params.value;
      switch (subscriptionValue) {
        case 'markany':
          subscriptionLabel = '마크애니';
          break;
        case 'google':
          subscriptionLabel = 'Google';
          break;
        case 'kakao':
          subscriptionLabel = '카카오';
          break;
      }
      return <TableCellTypography>{subscriptionLabel}</TableCellTypography>;
    },
  },
  {
    field: 'userUid',
    headerName: '아이디', // ID
    headerAlign: 'left',
    align: 'left',
    flex: 2,
    maxWidth: 160,
    minWidth: 160,
    renderCell: (params: GridRenderCellParams) => {
      return <TableCellTypography>{params.value ?? '--'}</TableCellTypography>;
    },
  },
  {
    field: 'userName',
    headerName: '성명', // Name
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 240,
    minWidth: 240,
    renderCell: (params: GridRenderCellParams) => {
      return <TableCellTypography>{params.value ?? '--'}</TableCellTypography>;
    },
  },
  {
    field: 'userEmail',
    headerName: '이메일', // Email
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 260,
    minWidth: 260,
    renderCell: (params: GridRenderCellParams) => {
      return <TableCellTypography>{params.value ?? '--'}</TableCellTypography>;
    },
  },
  {
    field: 'userSt',
    headerName: '직원 상태', // Employee Status
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 190,
    minWidth: 190,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => {
      let userStatusLabel = '--';
      const userStatusValue = params.value;
      switch (userStatusValue) {
        case 10:
          userStatusLabel = '신청';
          break;
        case 50:
          userStatusLabel = '정상';
          break;
        case 80:
          userStatusLabel = '일시정지';
          break;
        case 90:
          userStatusLabel = '퇴사';
          break;
      }

      return <TableCellTypography>{userStatusLabel}</TableCellTypography>;
    },
  },
  {
    field: 'regDt',
    headerName: '등록일시', // Registration Date and Time
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    sortable: true,
    maxWidth: 360,
    minWidth: 360,
    renderCell: (params: GridRenderCellParams) => {
      return <TableCellTypography>{params.value ?? '--'}</TableCellTypography>;
    },
  },
];
